  import { PostHogConfig } from "posthog-js";
  
  const apiKey = process.env.EXPO_PUBLIC_POSTHOG_API_KEY!;
  const options: Partial<PostHogConfig> = {
    api_host: "https://us.i.posthog.com",
  };
  
  export { apiKey, options };